"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if the given value is `null`.
 *
 * @example
 * ```ts
 * isNull(1); // false
 * isNull('1'); // false
 * isNull(undefined); // false
 * isNull(null); // true
 * ```
 */
var isNull = function (input) { return input === null; };
exports.default = isNull;
//# sourceMappingURL=isNull.js.map